import { logger as LOG } from '@sweetgreen/garnish';

// ────────────────────────────────────────────────────────────────────────────────
// LOG.enable('URQL');
export const logger = LOG.extend('URQL');
// ────────────────────────────────────────────────────────────────────────────────
